import { IoSearchOutline } from "react-icons/io5";
import { MdCancel } from "react-icons/md";
import { Table, Input, Form, Tabs } from "antd";
import React, { useState } from "react";
import { BsFillBuildingsFill } from "react-icons/bs";
import { BiSolidMessage } from "react-icons/bi";
import "../../../../Style/Dashboard/RecordQuickView/RecordQuickView.scss";
export default function AllFiles() {
  const onChangeTab = (key) => {
    console.log(key);
    setActiveTab(key);
  };
  const [activeTab, setActiveTab] = useState("1");
  const commonColumns = [
    {
      title: "Received",
      dataIndex: "received",
    },
    {
      title: "Address",
      dataIndex: "address",
    },
    {
      title: "Complaint # ",
      dataIndex: "complaint",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Category",
      dataIndex: "category",
    },

    {
      title: "Action",
      dataIndex: "action",
      render: () => (
        <IoSearchOutline
          style={{
            color: "#69b1ff",
            fontSize: "30px",
            marginLeft: "4px",
          }}
        />
      ),
    },
    {
      title: "Hired",
      dataIndex: "hired",
      render: () => (
        <MdCancel
          style={{
            color: "red",
            fontSize: "30px",
            marginLeft: "5px",
          }}
        />
      ),
    },
  ];

  const columns = [...commonColumns];
  if (activeTab === "1") {
    columns.push({
      title: "Status",
      dataIndex: "status",
    });
  }

  const tabData = {
    1: [
      {
        key: "1",
        received: "12/28/2023",
        address: "328 Atlantic Avenue",
        complaint: "3941200",
        type: "Stop Work Order",
        category: "(1X) Construction Enforcement...",
        status: "Active",
        action: "",
        hired: "",
      },
      {
        key: "2",
        received: "12/28/2023",
        address: "328 Atlantic Avenue",
        complaint: "3941200",
        type: "Stop Work Order",
        category: "(1X) Construction Enforcement...",
        status: "Active",
        action: "",
        hired: "",
      },
      {
        key: "3",
        received: "12/28/2023",
        address: "328 Atlantic Avenue",
        complaint: "3941200",
        type: "Stop Work Order",
        category: "(1X) Construction Enforcement...",
        status: "Active",
        action: "",
        hired: "",
      },
      {
        key: "4",
        received: "12/28/2023",
        address: "328 Atlantic Avenue",
        complaint: "3941200",
        type: "Stop Work Order",
        category: "(1X) Construction Enforcement...",
        status: "Active",
        action: "",
        hired: "",
      },
      {
        key: "5",
        received: "12/28/2023",
        address: "328 Atlantic Avenue",
        complaint: "3941200",
        type: "Stop Work Order",
        category: "(1X) Construction Enforcement...",
        status: "Active",
        action: "",
        hired: "",
      },
      {
        key: "1",
        received: "12/28/2023",
        address: "328 Atlantic Avenue",
        complaint: "3941200",
        type: "Stop Work Order",
        category: "(1X) Construction Enforcement...",
        status: "Active",
        action: "",
        hired: "",
      },
    ],
    2: [
      {
        key: "1",
        received: "9/6/2018",
        address: "227 Clarkson Avenue",
        complaint: "3666153",
        type: "Stop Work Order",
        category: "(83) Construction - Contrary/...",
        action: "",
        hired: "",
      },
      {
        key: "2",
        received: "9/6/2018",
        address: "227 Clarkson Avenue",
        complaint: "3666153",
        type: "Stop Work Order",
        category: "(83) Construction - Contrary/...",
        action: "",
        hired: "",
      },
    ],
    3: [
      {
        key: "3",
        received: "9/6/2018",
        address: "227 Clarkson Avenue",
        complaint: "3666153",
        type: "Stop Work Order",
        category: "(83) Construction - Contrary/...",
        action: "",
        hired: "",
      },
      {
        key: "4",
        received: "9/6/2018",
        address: "227 Clarkson Avenue",
        complaint: "3666153",
        type: "Stop Work Order",
        category: "(83) Construction - Contrary/...",
        action: "",
        hired: "",
      },
      {
        key: "5",
        received: "9/6/2018",
        address: "227 Clarkson Avenue",
        complaint: "3666153",
        type: "Stop Work Order",
        category: "(83) Construction - Contrary/...",
        action: "",
        hired: "",
      },
      {
        key: "6",
        received: "9/6/2018",
        address: "227 Clarkson Avenue",
        complaint: "3666153",
        type: "Stop Work Order",
        category: "(83) Construction - Contrary/...",
        action: "",
        hired: "",
      },
      {
        key: "7",
        received: "9/6/2018",
        address: "227 Clarkson Avenue",
        complaint: "3666153",
        type: "Stop Work Order",
        category: "(83) Construction - Contrary/...",
        action: "",
        hired: "",
      },
      {
        key: "8",
        received: "9/6/2018",
        address: "227 Clarkson Avenue",
        complaint: "3666153",
        type: "Stop Work Order",
        category: "(83) Construction - Contrary/...",
        action: "",
        hired: "",
      },
      {
        key: "9",
        received: "9/6/2018",
        address: "227 Clarkson Avenue",
        complaint: "3666153",
        type: "Stop Work Order",
        category: "(83) Construction - Contrary/...",
        action: "",
        hired: "",
      },
    ],
  };
  tabData[2].forEach((item) => delete item.status);
  return (
    <div>
      <div className="inputMain-calender">
        <Form.Item>
          <Input
            style={{ margin: "auto", width: "80%" }}
            placeholder="Building Filter"
            prefix={<BsFillBuildingsFill />}
          />
        </Form.Item>
      </div>

      <div className="main-dob-Active-record">
        <div className="main-logo-tabs">
          <BiSolidMessage
            style={{ color: "#478eca", fontSize: "25px", fontWeight: "600" }}
          />

          <h4
            style={{
              color: "#478eca",
              fontSize: "23px",
              fontWeight: "600",
              marginLeft: "5px",
            }}
          >
            *ALL *FILES
          </h4>
        </div>
        <div className="main-tabs">
          <Tabs onChange={onChangeTab} type="card" activeKey={activeTab}>
            <Tabs.TabPane tab="ALL" key="1"></Tabs.TabPane>
            <Tabs.TabPane tab="DOB CERT" key="2"></Tabs.TabPane>
            <Tabs.TabPane tab="DEED" key="3"></Tabs.TabPane>
            <Tabs.TabPane tab="DOF VALUE" key="4"></Tabs.TabPane>
            <Tabs.TabPane tab="DOF TAX" key="5"></Tabs.TabPane>
            <Tabs.TabPane tab="FDNY LETTER" key="6"></Tabs.TabPane>
          </Tabs>
        </div>
      </div>
      <Table columns={columns} dataSource={tabData[activeTab]} size="middle"  />
    </div>
  );
}
